import React from 'react';
import OptimizePlanTableHeader, { TableHeader } from './OptimizePlanTableHeader';
import OptimizeTableContent, { InputTypes } from './OptimizeTableContent';
import { OptimisationPlanData } from '../OptimizePlan';

interface IProps {
    tableData: OptimisationPlanData[];
    setTableData: React.Dispatch<React.SetStateAction<any>>;
    headerColumns: TableHeader[];
}

const OptimizePlanTable: React.FC<IProps> = ({ tableData, setTableData, headerColumns }) => {
    return (
        <div className="border border-[rgba(240,240,240,1)] rounded max-h-[92%] flex flex-col">
            <div className="sticky top-0 bg-white z-10">
                <OptimizePlanTableHeader headerColumns={headerColumns} />
            </div>

            <div className="overflow-y-auto flex-grow">
                {tableData.map((item, index) => (
                    <OptimizeTableContent key={item.name} rowData={item} setTableData={setTableData} index={index} />
                ))}
            </div>
        </div>
    );
};

export default React.memo(OptimizePlanTable);
